module.exports = __webpack_public_path__ + "static/media/iconfont.dfebf000.ttf";